// extracted by mini-css-extract-plugin
module.exports = {"container":"cancel-button__container___Vb1Yh"};